const TITLES = {
  AUDITS: 'Audits',
  BI_REPORTS: 'BI Reports',
  QUALITY_CONTROL: 'Quality Control',
  CS_REPORTS: 'CS Reports',
  DASHBOARDS: 'Dashboards',
  HOLIDAYS: 'Holidays',
  LOCATIONS: 'Locations',
  PROMO_CODES: 'Promo Codes',
  QUEUES: 'Queues',
  SCHEDULE: 'Schedule',
  SERVICES: 'Services',
  SMALL_PART_INVENTORY: 'Small Part Inventory',
  TR_SALES: 'TR Sales',
  TECHNICIANS: 'Technicians',
  TECHNICIAN_SCORECARD: 'Technician Scorecards',
  USER_MANAGEMENT: 'User Management',
  VANS: 'Vans',
  WORK_ORDERS: 'Work Orders',
}

export { TITLES }
